import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=a0136420&scoped=true&"
import script from "./InputGroup.vue?vue&type=script&lang=js&"
export * from "./InputGroup.vue?vue&type=script&lang=js&"
import style0 from "./InputGroup.vue?vue&type=style&index=0&id=a0136420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0136420",
  null
  
)

export default component.exports